import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'

import MoveToExistingTopicModal from './MoveToExistingTopicModal'

/* eslint-disable import/no-internal-modules */
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'

interface MoveToTopicProps {
  replyId?: string
  topicId?: number
  contentType: ContentType
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  getReplies?: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  publicId?: string
  visibleReplyCount?: number | null
}

interface MoveToTopicState {
  showMoveToExistingTopicModal: boolean
}

class MoveToTopic extends PureComponent<MoveToTopicProps, MoveToTopicState> {
  constructor() {
    super()
    this.state = {
      showMoveToExistingTopicModal: false
    }
  }

  showMoveToExistingTopicModal(show: boolean) {
    this.setState({ showMoveToExistingTopicModal: show })
  }

  // TODO: uncomment when doing CAN-780
  // showMoveToNewTopicModal(show: boolean) {
  //   this.setState({showMoveToNewTopicModal: show})
  // }

  render() {
    const { replyId, topicId, onShowAlert, contentType, getReplies, publicId, visibleReplyCount } = this.props
    const { showMoveToExistingTopicModal } = this.state

    const moveToExistingTopic = {
      title: 'Move to existing topic',
      onClick: () => this.showMoveToExistingTopicModal(true),
      variant: 'primary'
    }

    // TODO: uncomment when doing CAN-780
    // const moveToNewTopic = {
    //   title: 'Move to new topic',
    //   onClick: () => this.showMoveToNewTopicModal(true),
    //   variant: 'primary'
    // }

    return (
      <div>
        <DropdownControl
          align='adjust'
          triggerClass='dropdown-wrapper'
          trigger={<Button icon='arrowDropdown' title='Move' data-qa='topic-moderation-move-to-topic' />}
          items={[moveToExistingTopic]}
        />

        {showMoveToExistingTopicModal && (
          <MoveToExistingTopicModal
            contentType={contentType}
            replyId={replyId ? parseInt(replyId) : undefined}
            topicId={topicId}
            moveType='Move to existing topic'
            onClose={() => this.showMoveToExistingTopicModal(false)}
            onShowAlert={onShowAlert}
            getReplies={getReplies}
            publicId={publicId}
            visibleReplyCount={visibleReplyCount}
          />
        )}

        {/* TODO: add showMoveToNewTopicModal when doing CAN-780 */}
      </div>
    )
  }
}

export default MoveToTopic
